import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import UserSingleReport from "../../../pages/userSingleReport/userSingleReport";
import SectionContent from "../../../components/sectionContent/sectionContent";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";

import { AppDispatch } from "../../../redux/reducer/store";

import { IUserOptions } from "../../../types/interfaces";
import { reducerGetReport } from "../../../redux/reducer/map/reducer/reducerMapsList";

const CustomerSingleReportSection = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { report } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );
  const { data } = useSelector((state: IUserOptions) => state.user.user);
  const { id } = useParams<{ id: string }>();

  const handleClick = () => {
    dispatch(reducerGetReport([report.pos.latitude, report.pos.longitude]));
  };

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        section="Отчеты"
        pageName="report"
        title={"Отчет №" + id}
        headBlockChildren={
          <>
            {data.settings?.reviewer && report && report?.isRateable && (
              <HeaderBtn
                content="Оценить работу"
                purpose="reportCheck"
                modalTitle="Оценить отчет"
              />
            )}
            <HeaderBtn
              content="Настройки"
              purpose="singleReportSettings"
              modalTitle="Настройки"
            />
          </>
        }
      >
        <div className="content__single_report">
          <div className="btns" style={{ margin: "0 0 7px 4px" }}>
            <Link to={`/reports/${id}`} className="tab">
              <div className="buttons__btn --active">Отчет</div>
            </Link>
            {(data.isCustomer && data?.settings?.posMap)
            && <Link to={'/map'} className="buttons__btn tab__reports_btn" onClick={handleClick} >Карта обслуживания</Link>
            }
          </div>
          <UserSingleReport />
        </div>
      </SectionContent>
    </div>
  );
};

export default CustomerSingleReportSection;
